import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { ProductProductionTableFilterSchema } from './-zod-schema';

// プロダクト詳細 > プロダクションタブ。
// URL search のスキーマだけここで定義し、コンポーネントは index.lazy.tsx 側で
// 遅延ロードして bundle 分割する（他のタブ・ページと同じ規約）。
export const Route = createFileRoute('/_stacktrace/products/$id/_layout/productions/')({
  validateSearch: zodValidator(ProductProductionTableFilterSchema)
});